export const localeWithoutRegionCode = (locale) =>
  locale.toLowerCase().split(/[_-]+/)[0];

export const getBrowserLanguage = () =>
  localeWithoutRegionCode(
    (navigator.languages && navigator.languages[0]) ||
      navigator.language ||
      navigator.userLanguage
  );
